import { stringify } from 'utils/query-string';
import { HttpClient } from 'api/http-client';
export var FileGroupSourceType = /*#__PURE__*/ function(FileGroupSourceType) {
    FileGroupSourceType["Company"] = "COMPANY";
    FileGroupSourceType["Project"] = "PROJECT";
    return FileGroupSourceType;
}({});
class FilesHttpClient extends HttpClient {
    async createFileGroup(payload) {
        return this.post(`/folders/${payload.sourceType}/${payload.sourceId}`, payload);
    }
    getFileGroups(source) {
        return this.get(`/folders?${stringify(source)}`);
    }
    getBulkProjectFileGroups(projectIds) {
        return this.get(`/folders/bulkList?${stringify({
            sourceType: 'PROJECT',
            sourceIds: projectIds.join(',')
        })}`);
    }
    getBulkProjectAttachments(projectIds) {
        return this.get(`/attachments/projects?${stringify({
            projectIds: projectIds.join(',')
        })}`);
    }
    async uploadFile(file, data, config) {
        if (!file.originFileObj) {
            return Promise.reject(new Error('file object is empty'));
        }
        const formData = new FormData();
        const fileMeta = {
            attachment: {
                name: file.name,
                publicVisibility: true
            },
            associatedEntity: {
                sourceType: data.source.sourceType,
                sourceId: data.source.sourceId
            }
        };
        const blob = new Blob([
            JSON.stringify(fileMeta)
        ], {
            type: 'application/json'
        });
        formData.append('file', file.originFileObj);
        formData.append('request', blob);
        const res = await this.post('/attachments', formData, config);
        return res.attachment;
    }
    async linkFiles(folderId, fileIds, sourceType, sourceId, config) {
        return this.post(`/folders/${folderId}/${sourceType}/${sourceId}/attachments/link`, fileIds, config);
    }
    async deleteFile(groupId, fileId, companyId) {
        return this.delete(`/folders/${groupId}/attachments/company/${companyId}`, {
            data: [
                fileId
            ]
        });
    }
    async rearrangeFiles(sourceType, sourceId, payload) {
        return this.put(`/folders/reorder-attachments/${sourceType}/${sourceId}`, payload);
    }
    async rearrangeFoldersForCompany(companyId, payload) {
        return this.put(`/companies/${companyId}/reorder-folder`, payload);
    }
    async deleteFileGroup(groupId, sourceType, sourceId) {
        return this.delete(`/folders/${groupId}/${sourceType}/${sourceId}`);
    }
    async updateFolder(groupId, payload, sourceType, sourceId) {
        return this.put(`/folders/${groupId}/${sourceType}/${sourceId}`, payload);
    }
    async changeFilePinnedStatus(fileId, isPinned) {
        return this.put(`/attachments/${fileId}`, {
            isPinned
        });
    }
    triggerEmailForFileGroup(groupId) {
        return this.get(`/folders/${groupId}/email`);
    }
    getFileGroupDownloadUrl(groupId) {
        return `${this.BASEURL}/folders/${groupId}/download`;
    }
    getFileDownloadUrl(groupId, fileId) {
        return `${this.BASEURL}/folders/${groupId}/attachments/${fileId}/download`;
    }
}
export const FilesAPI = new FilesHttpClient();
